module.exports = __webpack_public_path__ + "static/f81afff9e8eb51a79b9e1653c4db6bc847e71ede4dc28f80aa11d8e959d629e9-9f5ae868f127f34249e3986525e1fdd2.jpeg";